/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PaginationModel from './PaginationModel';
import PublishHouseDto from './PublishHouseDto';

/**
 * The SearchingQueryResponseModelPublishHouseDto model module.
 * @module model/SearchingQueryResponseModelPublishHouseDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelPublishHouseDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelPublishHouseDto</code>.
     * @alias module:model/SearchingQueryResponseModelPublishHouseDto
     */
    constructor() { 
        
        SearchingQueryResponseModelPublishHouseDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelPublishHouseDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelPublishHouseDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelPublishHouseDto} The populated <code>SearchingQueryResponseModelPublishHouseDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelPublishHouseDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [PublishHouseDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelPublishHouseDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/PublishHouseDto>} result
 */
SearchingQueryResponseModelPublishHouseDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelPublishHouseDto;

